var _path, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFitty(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 34,
    height: 36,
    viewBox: "0 0 34 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.275 36L31.875 28.8L33.2363 7.2L18.275 11.5172V36ZM1.95898 28.8L15.559 36V11.5172L0.597656 7.2L1.95898 28.8ZM16.9203 0L0.597656 4.31719L16.9203 8.63438L33.243 4.31719L16.9203 0Z",
    fill: "url(#paint0_linear_232_108)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_232_108",
    x1: 16.9203,
    y1: 0,
    x2: 16.9203,
    y2: 36,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E0A714"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EF8829"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFitty);
export default __webpack_public_path__ + "static/media/fitty.029578d1307a4abcf02738c4f7d892e9.svg";
export { ForwardRef as ReactComponent };